import { Checkbox, FormControlLabel, FormGroup, FormLabel, Stack } from '@mui/material';
import ChannelsAutoLoad from 'common/features/channels/ChannelsAutoLoad';
import useFlexBoxStyles from 'common/flexBox';
import { useTranslation } from 'react-i18next';

const EventFormSettingsChannels = ({
    channelSubscriptionEnable,
    event,
    handleFieldChange,
    channelSelectionRequired,
}) => {
    const { t } = useTranslation();
    const { classes: flexBox, cx } = useFlexBoxStyles();

    const handleCheckChange = (e, name) => {
        handleFieldChange({
            target: {
                name: name,
                value: e.target.checked,
            },
        });
        handleFieldChange({
            target: {
                name: 'notifySubscribers',
                value: e.target.checked,
            },
        });
    };

    const onChange = (channelsIds) => {
        handleFieldChange({
            target: {
                name: 'channelsIds',
                value: channelsIds,
            },
        });
    };

    return (
        <>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            className={cx(flexBox.padding0, flexBox.margin01)}
                            checked={event.isPublic}
                            onChange={(e) => handleCheckChange(e, 'isPublic')}
                            name="isPublic"
                            color="primary"
                        />
                    }
                    label={<FormLabel>{t('event.eventFormSettings.enableTv')}</FormLabel>}
                />
            </FormGroup>

            {event.isPublic && (channelSelectionRequired || channelSubscriptionEnable) && (
                <Stack direction="column" spacing={2}>
                    {channelSelectionRequired && (
                        <>
                            <FormLabel>{t('event.eventFormSettings.othersChannels')}</FormLabel>
                            <ChannelsAutoLoad channelsIds={event?.channelsIds} onChange={onChange} />
                        </>
                    )}

                    {channelSubscriptionEnable && (
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        className={cx(flexBox.padding0, flexBox.margin01)}
                                        checked={event.notifySubscribers}
                                        onChange={(e) => handleCheckChange(e, 'notifySubscribers')}
                                        name="notifySubscribers"
                                        color="primary"
                                    />
                                }
                                label={<FormLabel>{t('event.eventFormSettings.enableNotifySubscribers')}</FormLabel>}
                            />
                        </FormGroup>
                    )}
                </Stack>
            )}
        </>
    );
};

export default EventFormSettingsChannels;
